import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const DragHandle: React.FC = () => {
  const { colors } = useThemeColors();
  return (
    <View style={styles.container}>
      <View style={[styles.handle, { backgroundColor: colors.card.border }]} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 4,
  },
  handle: {
    width: 36,
    height: 4,
    borderRadius: 2,
  },
});
